import React, { useState, useEffect, useRef } from 'react';
import { callService } from "@Utils/ServiceUtils";
import { isEmpty, getLanguage, langChangeMsg } from '@Views/utils/StringUtils';
import { Viewer } from '@toast-ui/react-editor';
import Popup from '@Views/comp/Popup';

import nosearchIcon from '@Images/icon-nosearch.png';

const EmploymentMain = ({ msg, viewChange }: any) => {

    let searchWordRef: any = useRef();
    let searchKindRef: any = useRef();
    let empState: any = useRef();
    let [searchResultWord, setSearchResultWord] = useState<string>();
    let [searchTotalCount, setSearchTotalCount] = useState<number>(0);
    let [selectedPagination, setSelectedPagination] = useState<number>(1);
    let [sttVal, setSttVal] = useState<string>("P");

    let [isBtnReset, setIsBtnReset] = useState<boolean>(false);

    let [svyrEmplyPbanList, setSvyrEmplyPbanList] = useState<any>([]);

    let [popNtc, setPopNtc] = useState<any>();
    const popupRef: any = useRef();

    const onClickBtnSearch = () => {
        OEMPA01R01(1, sttVal);
    }

    const onClickBtnReset = () => {
        searchWordRef['current']['value'] = null;
        setIsBtnReset(false);
    }

    const onChangeState = (e: any) => {
        const val = e.currentTarget.value;

        setSttVal(val);
        setSelectedPagination(1);

        OEMPA01R01(1, val);
    }

    const onKeyUpSearchWord = (e: any) => {

        if (e.key === "Enter" || e.type === "click") {
            OEMPA01R01(1, sttVal);
        }

        if (e.type === "keyup") {
            if (searchWordRef['current']['value'])
                setIsBtnReset(true);
            else
                setIsBtnReset(false);
        }

    }

    const OEMPA01R01 = async (pageNumber: number, sttVal?: string) => {

        let searchWord = searchWordRef['current']['value'].trim();
        let searchKind = searchKindRef['current']['value'];

        if (!isEmpty(searchWord)) {
            const regExp = /[\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g;
            if (regExp.test(searchWord)) {
                let text = searchWord.replaceAll(/[^\{\}\[\]\/?.,;:|\)*~`!^\-_+<>@\#$%&\\\=\(\'\"]/g, '');
                alert('특수문자(' + text + ')는 형식에 맞지않습니다.');
                return;
            }

        }

        const param = {
            svyrEmplyPbanNm: searchKind === '01' ? searchWord : searchKind === '02' ? searchWord : '',
            dptNm: searchKind === '01' ? searchWord : searchKind === '03' ? searchWord : '',
            sttVal: !isEmpty(sttVal) && sttVal,
            pageNum: pageNumber
        }

        const res = await callService("OEMPA01R01", param);

        setSvyrEmplyPbanList(res['list']);
        setSearchTotalCount(res['allCcnt']);
        setSearchResultWord(searchWord);

    }

    const renderPagination = () => {
        let paginationCount = searchTotalCount === 0 ? 1 : Math.ceil(searchTotalCount / 10);
        let pageLevel = 1;

        return (
            <>
                {Array.from(Array(paginationCount), (e, i) => {

                    let pageNum = i + 1;
                    let page = <li className={"pagination_btn" + (Math.ceil(selectedPagination / 10) === pageLevel ? '' : ' displayNone')} key={i}><button type="button" className={"list_move" + (selectedPagination === i + 1 ? ' active' : '')} onClick={(e) => onClickBtnPagination('page', pageNum)}>{pageNum}</button></li>;

                    if (pageNum % 10 === 0) {
                        pageLevel++;
                    }

                    return page;
                })}
            </>
        )

    }

    const onClickBtnPagination = (type: string, selectedNumber: number) => {

        let paginationCount = searchTotalCount === 0 ? 1 : Math.ceil(searchTotalCount / 8);
        let pageNumber = 1;

        if (type === 'page') {
            pageNumber = selectedNumber;
        }
        else if (type === 'first') {
            pageNumber = 1;
        }
        else if (type === 'before') {
            if (selectedPagination !== 1)
                pageNumber = (selectedPagination - 1);
            else
                pageNumber = 1;
        }
        else if (type === 'after') {
            if (selectedPagination !== paginationCount)
                pageNumber = (selectedPagination + 1);
            else
                pageNumber = selectedPagination;
        }
        else if (type === 'last') {
            pageNumber = paginationCount;
        }

        setSelectedPagination(pageNumber);

        if (selectedPagination !== pageNumber)
            OEMPA01R01(pageNumber, sttVal);

    }

    const onClickBtnDetail = (svyrEmplyPbanNo: string) => {
        viewChange(svyrEmplyPbanNo);
    }

    // 공지사항팝업조회
    const OSMBA01R03 = async () => {

        const param = {
            langCd: getLanguage().toUpperCase(),
            sysCd: '05',
            useYn: 'Y'
        }

        const res = await callService("OSMBA01R03", param);

        if (res != null) {

            if (isEmpty(res['ntcList']) === false) {

                setPopNtc(res['ntcList'][0]);

                const cookie: any = document.cookie;
                if (isEmpty(cookie) === false) {

                    let isRecruitPopNtcShow = true;

                    let cookieEach = cookie.split('; ');

                    cookieEach.forEach(function (each: string) {
                        let cookieName = each.split('=');
                        cookieName.forEach(function (name: string) {
                            if (name === 'isRecruitPopNtcShow') {
                                isRecruitPopNtcShow = false;
                            }
                        });
                    });

                    if (!isRecruitPopNtcShow) {
                        // 팝업 호출 X
                    }
                    else {
                        // 팝업 호출 O
                        popupRef['current'].isOpen(true);
                    }

                }
                else {
                    // 팝업 호출 O
                    popupRef['current'].isOpen(true);
                }

            }

        }

    }

    const onChangeCheckboxPopNtcShow = () => {

        let todayDate = new Date();
        todayDate.setDate(todayDate.getDate() + 30);

        document.cookie = 'isRecruitPopNtcShow=false; path=/; expires=' + todayDate.toUTCString() + ';';
        popupRef['current'].isOpen(false);

    }

    useEffect(() => {

        OEMPA01R01(1, sttVal);
        OSMBA01R03();

    }, []);

    return (
        <>
            {
                !isEmpty(popNtc) &&
                <Popup className="modal-sm" title={popNtc['ntcTtlNm']} ref={popupRef}>
                    <fieldset style={{ padding: '30px', wordBreak: 'break-word', overflowWrap: 'break-word' }}>
                        {<Viewer initialValue={popNtc['ntcCtnt']} key={popNtc['ntcCtnt']} />}
                    </fieldset>
                    <div className="btn-wrap">
                        <div className="form-group form-group-checkbox">
                            <div className="input-box-group" style={{ float: 'right', padding: '10px' }}>
                                <div className="input-box">
                                    <div className="input-group">
                                        <input id="termsAgree" type="checkbox" className="form-control form-control-sm" onChange={onChangeCheckboxPopNtcShow} />
                                        <label htmlFor="termsAgree"><span>{langChangeMsg("30일 동안 보지 않기", "Don't show again for 30 days")}</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Popup>
            }

            <div className="wrap-body">
                <div className="employment-system-wrap">
                    <div className="employment-top-inner">
                        <div className="employ-info-title">
                            <h2>통계조사보조원 채용안내</h2>
                            <p>한국은행에서 다음과 같이 통계조사보조원을 모집합니다.</p>
                        </div>
                    </div>
                    <div className="employment-contents-inner" style={{ paddingBottom: "36px" }}>
                        <div className="searh_wrapStyle01 faq_custom">
                            <div className="searchContainer">
                                <div className="form-group">
                                    <div className="input-box-group">
                                        <div className="input-box input-box-select">
                                            <label htmlFor="SELECT1" className="text-hide">통계메타 검색 카테고리 선택</label>
                                            <select name="SELECT1" id="SELECT1" className="form-control" ref={searchKindRef}>
                                                <option value="01">공고명+부서명</option>
                                                <option value="02">공고명</option>
                                                <option value="03">부서명</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="form-group form-group-search">
                                    <div className="input-box-group">
                                        <div className="input-box">
                                            <label htmlFor="search" className="text-hide"><span className="text-hide">검색어입력</span></label>
                                            <input className="form-control" type="text" id="search" placeholder="검색어를 입력해주세요." ref={searchWordRef} onKeyUp={onKeyUpSearchWord} /><i></i>
                                        </div>
                                    </div>
                                    {
                                        isBtnReset &&
                                        <div className="btn-reset">
                                            <button type="button" className="btn" onClick={onClickBtnReset}><span className="text-hide">삭제</span></button>
                                        </div>
                                    }
                                    <div className="btn-search btn-search-02">
                                        <button type="button" className="btn" onClick={onClickBtnSearch}><span className="text-hide">검색</span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="board_listCompent board_listCompent-02 employment-system-board">
                            <div style={{ textAlign: "center", color: "#4c84ff" }}>
                                <p>통계조사보조원 채용 페이지는 크롬 브라우저에서 최적화되었습니다.</p>
                            </div>
                            <div className="boardTop_box">
                                <div className="leftBox">
                                    <div className="boardCount_text">
                                        {
                                            searchResultWord ?
                                                <>
                                                    '<span className="searchTxt">{searchResultWord}</span>'&nbsp;
                                                    <span className="cate">검색결과</span>
                                                </>
                                                :
                                                <>
                                                    <span className="cate">총</span>
                                                </>
                                        }
                                        <span className="count">{searchTotalCount}</span>건
                                    </div>
                                </div>
                                <div className="rightBox">
                                    <div className="chartOptions clearfix">
                                        <div className="flxLeft flxBox">
                                            <div className="selectBox">
                                                <div className="form-group">
                                                    <div className="input-box-group">
                                                        <div className="input-box input-box-select">
                                                            <select className="form-control form-control-sm" onChange={onChangeState} ref={empState}>
                                                                <option value="P">모집중</option>
                                                                <option value="C">마감</option>
                                                                <option value="">전체</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="board_contentsBox">
                                <ul className="board_header">
                                    <li className="board_items">
                                        <div className="board_list_titBox">
                                            <div className="leftBox titTxtBox">
                                                <div className="board_num">모집번호</div>
                                                <div className="tit">모집공고명</div>
                                            </div>
                                            <div className="board_list_info">
                                                <div className="organization_name">모집부서명</div>
                                                <div className="recruit_date">모집기간</div>
                                                <div className="recruit_status">상태</div>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                {svyrEmplyPbanList.length > 0 ?
                                    <ul className="board_list">
                                        {
                                            svyrEmplyPbanList.map((svyrEmplyPban: any, index: number) => (
                                                <li className="board_items" key={index}>
                                                    <div className="board_list_titBox" onClick={() => { onClickBtnDetail(svyrEmplyPban['svyrEmplyPbanNo']) }}>
                                                        <div className="leftBox titTxtBox">
                                                            <div className="board_num">{svyrEmplyPban['svyrEmplyPbanNo']}</div>
                                                            <div className="tit">
                                                                <a className="boardLink">{svyrEmplyPban['svyrEmplyPbanNm']}</a>
                                                            </div>
                                                        </div>
                                                        <div className="board_list_info">
                                                            <div className="organization_name">{svyrEmplyPban['dptNm']}</div>
                                                            <div className="recruit_date">{svyrEmplyPban['svyrEmplyPbanStDtm']} ~ {svyrEmplyPban['svyrEmplyPbanEndDtm']}</div>
                                                            {
                                                                svyrEmplyPban['sttVal'] === 'P' && <div className="recruit_status"><span className="status_badge in-progress">모집중</span></div>
                                                            }
                                                            {
                                                                svyrEmplyPban['sttVal'] === 'C' && <div className="recruit_status"><span className="status_badge done">마감</span></div>
                                                            }
                                                        </div>
                                                    </div>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    :
                                    <div className="noDataBox">
                                        <div className="noData">
                                            <div className="imgBox">
                                                <img src={nosearchIcon} />
                                            </div>
                                            <div className="txt">검색 결과가 없습니다.</div>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                        <div className="pagination_box">
                            <ul className="pagination">
                                <li className="pagination_btn">
                                    <button type="button" className="list_move list_first" onClick={(e) => onClickBtnPagination('first', 0)}>
                                    </button>
                                </li>
                                <li className="pagination_btn">
                                    <button type="button" className="list_move list_prev" onClick={(e) => onClickBtnPagination('before', 0)}>
                                    </button>
                                </li>
                                {renderPagination()}
                                <li className="pagination_btn">
                                    <button type="button" className="list_move list_next" onClick={(e) => onClickBtnPagination('after', 0)}>
                                    </button>
                                </li>
                                <li className="pagination_btn">
                                    <button type="button" className="list_move list_last" onClick={(e) => onClickBtnPagination('last', 0)}>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
        </>
    );

}

export default EmploymentMain;